import { render } from "./modal-form.vue?vue&type=template&id=a66b2eca"
import script from "./modal-form.vue?vue&type=script&lang=js"
export * from "./modal-form.vue?vue&type=script&lang=js"

import "./modal-form.vue?vue&type=style&index=0&id=a66b2eca&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__